<template><!-- svgo-optimised -->
<svg class="icon icon__plus" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="5.625" width="0.75" height="12" fill="white"/>
<rect y="5.625" width="12" height="0.75" fill="white"/>
</svg>
</template>